export default {

  // erstellt das json basis root für xml bpmn dateien
  newDoc() {
    return {
      encoding: "UTF-8",
      root: {
        localName: "definitions",
        nodeName: "definitions",
        type: 1,
        ns: "http://www.omg.org/spec/BPMN/20100524/MODEL",
        children: [],
        attributes: {
            "typeLanguage":{"localName":"typeLanguage","nodeName":"typeLanguage","value":"http://www.w3.org/2001/XMLSchema"},
            "expressionLanguage":{"localName":"expressionLanguage","nodeName":"expressionLanguage","value":"http://www.w3.org/1999/XPath"},
            "targetNamespace":{"localName":"targetNamespace","nodeName":"targetNamespace","value":"http://www.activiti.org/test"}
          }
        }
      };
  },

  // neuen prozess knoten erstellen
  newProcess(id,name) {
    return {
      localName: "process",
      nodeName: "process",
      type: 1,
      ns: "http://www.omg.org/spec/BPMN/20100524/MODEL",
      children: [],
      attributes: {
        "isExecutable":{"localName":"isExecutable","nodeName":"isExecutable","value":"true"},
        "id": {"localName":"id","nodeName":"id","value": id},
        "name": {"localName":"name","nodeName":"name","value":name}
      }
    };
  },

  // xml diagram root erstellen
  newDiagram(procid) {
    return {
      localName: "BPMNDiagram",
      nodeName: "bpmndi:BPMNDiagram",
      type: 1,
      ns: "http://www.omg.org/spec/BPMN/20100524/DI",
      children: [],
      attributes: {
        "id":{"localName":"id","nodeName":"id", "value":"BPMNDiagram_" + procid}
      }
    };
  },

  // diagram plane erstellen (aktuell immer nur eine)
  newDiagramPlane(name) {
    return {
      localName: 'BPMNPlane',
      nodeName: 'bpmndi:BPMNPlane',
      ns: "http://www.omg.org/spec/BPMN/20100524/DI",
      type: 1,
      children: [],
      attributes: {
        "bpmnElement": { "localName": "bpmnElement", "nodeName":"bpmnElement", "value": name },
        "id": {"localName":"id","nodeName":"id", "value":"BPMNPlane_" + name}
      }
    };
  },

  // basis knoten (rechteck) erstellen
  newRectNode(name,x,y,width,height) {
    return {
      localName: 'BPMNShape',
      nodeName: 'bpmndi:BPMNShape',
      ns: "http://www.omg.org/spec/BPMN/20100524/DI",
      type: 1,
      attributes: {
        "bpmnElement": { "localName": "bpmnElement", "nodeName":"bpmnElement", "value": name },
        "id": {"localName":"id","nodeName":"id", "value":"BPMNShape_" + name }
      },
      children: [
        // position and size
        {
          "localName":"Bounds",
          "nodeName":"omgdc:Bounds",
          "ns": "http://www.omg.org/spec/DD/20100524/DC",
          type: 1,
          attributes: {
            "height": { "localName": "height", "nodeName":"height", "value": height },
            "width":  { "localName": "width", "nodeName":"width", "value":  width },
            "x":      { "localName": "x", "nodeName":"x", "value": x },
            "y":      { "localName": "y", "nodeName":"y", "value": y }
          }
        }
      ]
    };
  },

  // erstellt json xml für eine kante
  newEdge(id) {
    return {
      "localName":"sequenceFlow",
      "nodeName":"sequenceFlow",
      "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
      "type":1,
      "attributes": {
        "id": {"localName":"id","nodeName":"id","value":id},
        "sourceRef": {"localName":"sourceRef","nodeName":"sourceRef","value":""},
        "targetRef":{"localName":"targetRef","nodeName":"targetRef","value":""}
      }
    };
  },

  // create a new json xml presentation of an activit expression element
  newExpressionChild() {
    return {
      "localName":"field",
      "nodeName":"field",
      "ns":"http://activiti.org/bpmn",
      "type":1,
      "attributes":{
        "name": {
          "localName":"name",
          "nodeName":"name",
          "value":""
        }
      },
      "children":[{
        "localName":"expression",
        "nodeName":"expression",
        "ns":"http://activiti.org/bpmn",
        "type":1,
        "children":[{
          "content":"",
          "type":4
        }]
      }]
    }
  },

  // create a new json xml presentation of an activit expression element
  newStringFieldChild() {
    return {
      "localName":"field",
      "nodeName":"field",
      "ns":"http://activiti.org/bpmn",
      "type":1,
      "attributes":{
        "name": {
          "localName":"name",
          "nodeName":"name",
          "value":""
        }
      },
      "children":[{
        "localName":"string",
        "nodeName":"string",
        "ns":"http://activiti.org/bpmn",
        "type":1,
        "children":[{
          "content":"",
          "type":4
        }]
      }]
    }
  },


  // create a parent extension bpmn element
  newExtensions() {
    return {
        "ns":"http://www.omg.org/spec/BPMN/20100524/MODEL",
        "localName":"extensionElements",
        "nodeName":"extensionElements",
        "type":1,
        "children":[]
    };
  },

  newConditionExpression() {
    return {
      "localName":"conditionExpression",
      "nodeName":"conditionExpression",
      "type":1,
      "ns":"http://www.omg.org/spec/BPMN/20100524/MODEL",
      "attributes": {
        "type":{
          "localName":"type",
          "nodeName":"xsi:type",
          "ns":"http://www.w3.org/2001/XMLSchema-instance",
          "value":"tFormalExpression"
        },
      },
      "children": [
        {
          "type":4,
          "content": ''
        }
      ]
    };
  },

  endEvent() {
    return {
      "localName":"endEvent",
      "nodeName":"endEvent",
      "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
      "type":1,
      "attributes": {
        "id": {"localName":"id","nodeName":"id","value":"endevent1"},
        "name":{"localName":"name","nodeName":"name","value":"End"}
      }
    };
  }


}
